<mat-dialog-content>
  <h1>Set Up a New Store</h1>
  <div class="setup-store-section">
    <div class="setup-store-input-header">Store Name:</div>
    @if (unusedFacilitiesLoaded) {
      <mat-form-field appearance="fill" class="setup-store-input-wrapper">
        <mat-label>Select setup store</mat-label>
        <mat-select [(value)]="selectedNewFacility" (selectionChange)="onStateChange()">
          <mat-option [value]="0">None</mat-option>
          @for (facility of unusedFacilities; track facility) {
            <mat-option [value]="facility"> {{ facility.facilityId }} - {{ facility.facilityName }} </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <h2>Contact Information</h2>
    <div class="setup-store-input-header">Fulfillment Contact Number:</div>
    <form [formGroup]="setupStoreForm">
      <div formGroupName="phone">
        <mat-form-field appearance="outline">
          <mat-label>Phone Number</mat-label>
          <input
            formControlName="number"
            type="tel"
            placeholder="(999) 999-9999"
            (input)="formatNumber()"
            [errorStateMatcher]="phoneErrorMatcher"
            matInput
            (change)="onStateChange()" />
        </mat-form-field>
      </div>
    </form>

    <h2>Import Default Settings</h2>
    <div class="store-setup-note">
      The following settings will be imported:<br />
      Hours of Operation, Walkpath Order, Hand-off Settings, Prep Locations, Manage Items
    </div>
    <div class="setup-store-input-container">
      <div class="setup-store-input-header">Import Settings from:</div>
      @if (sourceHandoffInfoLoaded) {
        <mat-form-field appearance="fill" class="setup-store-input-wrapper">
          <mat-label>Select setup store</mat-label>
          <mat-select [(value)]="selectedSourceHandoffInfo" (selectionChange)="onStateChange()">
            <mat-option [value]="0">None</mat-option>
            @for (handoffInfo of sourceHandoffInfo; track handoffInfo) {
              <mat-option [value]="handoffInfo">
                {{ handoffInfo.facilityId }} - {{ handoffInfo.facilityName }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
    </div>

    <div class="dark-gray-text store-setup-footer">
      Your new store will remain CLOSED until you have reviewed all imported settings and mark the store as open.
    </div>
    <div class="action-container">
      <button mat-button color="warn" (click)="onNoClick()">Exit</button>
      <button mat-flat-button color="accent" [disabled]="saveButtonOff" (click)="setupNewFacility()">
        Save Changes
      </button>
    </div>
  </div>
</mat-dialog-content>
